import React, { useMemo } from "react";
import {
  ExcelExportColumn,
  ExcelExport,
} from "@progress/kendo-react-excel-export";
import { useTranslation } from "react-i18next";
import { formatDateWithTime } from "utils/pdf";
import { useAppStoreState } from "store/AppStore";
import { infoEntriesColumnConfig as bankStatementInfoEntriesColumnConfig } from "pages/BankStatements/BankStatementEntriesGrid/InfoBankStatementEntryDialog/infoEntriesColumnConfig";
import { transformRowsForExcel } from "pages/BankStatements/BankStatementEntriesGrid/InfoBankStatementEntryDialog/ExportExcel";
import { useClientBalancePageStoreState } from "store/ClientBalancePageStore";

type Props = {};

export const PaymentsByClientSaldoEntryExportExcel = React.forwardRef<
  ExcelExport,
  Props
>((props, ref) => {
  const { t } = useTranslation();
  const cols = bankStatementInfoEntriesColumnConfig;
  const actualColumns = cols.filter(
    (c) =>
      c.columnId !== "ordinalNumber" &&
      c.columnId !== "select" &&
      c.columnId !== "paymentoptions" &&
      c.columnId !== "lastModified"
  );
  const { taxonomy } = useAppStoreState();
  const { paymentsByClientSaldoEntry } = useClientBalancePageStoreState();

  const data = useMemo(() => {
    return transformRowsForExcel({
      rows: paymentsByClientSaldoEntry.map((payment: any) => {
        return {
          ...payment,
          clientName:
            payment.clientName === null
              ? payment.clientLastName + " " + payment.clientFirstName
              : payment.clientName,
        };
      }),
      columns: actualColumns,
      t,
      taxonomy,
    });
  }, [actualColumns, paymentsByClientSaldoEntry, taxonomy, t]);

  return (
    <ExcelExport
      data={data}
      ref={ref}
      fileName={`Payments by client saldo entry ${formatDateWithTime(
        new Date()
      )}.xlsx`}
    >
      {actualColumns.map((col) => {
        let format = null;
        let align: "center" | "left" | "right" = "center";
        if (col.cellType === "customtext") {
          format = "text";
          align = "left";
        } else if (col.cellType === "customnumber") {
          format = "#,##0.00";
          align = "right";
        } else if (col.cellType === "datepicker") {
          format = "dd/MM/yyyy";
          align = "center";
        } else if (col.cellType === "taxonomy") {
          format = "text";
          align = "left";
        } else if (col.cellType === "customcheckmark") {
          format = "text";
          align = "left";
        }
        return (
          <ExcelExportColumn
            key={col.columnId}
            field={col.columnId}
            title={t(col.label)}
            cellOptions={{ format: format }}
            width={col.width}
            headerCellOptions={{
              background: "#005aa1",
              color: "#fff",
              textAlign: align,
            }}
          />
        );
      })}
    </ExcelExport>
  );
});
